import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const Presentation = styled.div`
  padding-top: 2px;
  width: 100%;
  margin-bottom: 70px;
`;

export const DivInformation = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 300px;
  width: 100%;

  .profilePhoto {
    border-radius: 50%;
    width: 200px;
    padding-top: 20px;
    margin: 12px;
  }

  h1 {
    font-size: 1.5rem;
    color: teal;
  }

  hr {
    width: 100%;
    position: relative;
    top: 30px;
  }
`;

export const Skills = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  h1 {
    font-size: 1.7rem;
    color: teal;
    padding-bottom: 5px;
  }
`;


export const DivTecnologies = styled.div`
  margin: 20px;
`;


export const Tecnologies = styled.div`
  display: grid;
  justify-items: center;
  width: 100%;

  .Icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 15px;
    height: 80px;
    width: 100%;
  }

  @media (min-width: 576px) {
    grid-template-columns: 1fr;
  }
  @media (min-width: 760px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: 960px) {
    grid-template-columns: 1fr 1fr;
    grid-gap: 5rem;
  }
  @media (min-width: 1440px) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 10rem;
  }
`;


export const DivLenguages = styled.div`
  margin: 20px;
`;


export const Lenguages = styled.div`
  display: grid;
  justify-items: center;
  width: 100%;

  .Icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 15px;
    height: 80px;
    width: 100%;
  }

  @media (min-width: 576px) {
    grid-template-columns: 1fr;
  }
  @media (min-width: 760px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (min-width: 960px) {
    grid-template-columns: 1fr 1fr;
    grid-gap: 5rem;
  }
  @media (min-width: 1440px) {
    grid-template-columns: 1fr 1fr;
    grid-gap: 15rem;
  }
`;

export const DivProjects = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  h1 {
    font-size: 1.7rem;
    color: teal;
    padding-bottom: 5px;
  }
  margin: 20px;
`;

export const Projects = styled.div`
  margin: 50px;
  padding-bottom: 20px;
`;
